import "../styles/DashboardCollectivite.css";
import React, { useMemo, useState, useEffect } from "react";
import { API_BASE } from "../config";

import {
  FaUsers,
  FaCalendarAlt,
  FaClock,
  FaChartLine
} from "react-icons/fa";

import { RendezVousCollectivite } from './PagePriseRDV.js';
import { BeneficiairesCollectivite } from './PageBeneficiaires.js';
import { ParametresCollectivite } from './PageModifProfil.js';

/* ===========================
   SIDEBAR ICONS
=========================== */
const Icons = {
  overview: (
    <svg viewBox="0 0 24 24">
      <path d="M3 13h8V3H3v10zm10 8h8V11h-8v10zM3 21h8v-6H3v6zm10-18v6h8V3h-8z" />
    </svg>
  ),
  users: (
    <svg viewBox="0 0 24 24">
      <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zM8 11c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5C15 14.17 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
    </svg>
  ),
  calendar: (
    <svg viewBox="0 0 24 24">
      <path d="M7 2v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-2V2h-2v2H9V2H7zm12 18H5V9h14v11z" />
    </svg>
  ),
  settings: (
    <svg viewBox="0 0 24 24">
      <path d="M19.14 12.94c.04-.31.06-.63.06-.94s-.02-.63-.06-.94l2.03-1.58a.5.5 0 0 0 .12-.64l-1.92-3.32a.5.5 0 0 0-.61-.22l-2.39.96a7.007 7.007 0 0 0-1.63-.94l-.36-2.54A.5.5 0 0 0 13.88 2h-3.76a.5.5 0 0 0-.49.42l-.36 2.54c-.6.24-1.16.56-1.63.94l-2.39-.96a.5.5 0 0 0-.61.22L2.72 8.48a.5.5 0 0 0 .12.64l2.03 1.58c-.04.31-.06.63-.06.94s.02.63.06.94l-2.03 1.58a.5.5 0 0 0-.12.64l1.92 3.32c.14.24.43.34.69.22l2.39-.96c.47.38 1.03.7 1.63.94l.36 2.54c.04.26.26.42.49.42h3.76c.26 0 .45-.16.49-.42l.36-2.54c.6-.24 1.16-.56 1.63-.94l2.39.96c.26.12.55.02.69-.22l1.92-3.32a.5.5 0 0 0-.12-.64l-2.03-1.58zM12 15.5A3.5 3.5 0 1 1 12 8a3.5 3.5 0 0 1 0 7.5z" />
    </svg>
  ),
  logout: (
    <svg viewBox="0 0 24 24">
      <path d="M10 17l1.41-1.41L8.83 13H20v-2H8.83l2.58-2.59L10 7l-5 5 5 5zM4 4h6V2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h6v-2H4V4z" />
    </svg>
  ),
};

const DashboardCollectivite = ({ user, onLogout }) => {
  const menuItems = useMemo(
    () => [
      { key: "overview", label: "Vue globale", icon: Icons.overview },
      { key: "beneficiaires", label: "Bénéficiaires", icon: Icons.users },
      { key: "rendezvous", label: "Rendez-vous", icon: Icons.calendar },
      { key: "settings", label: "Paramètres", icon: Icons.settings },
    ],
    []
  );

  const [active, setActive] = useState("overview");
  const [confirmLogout, setConfirmLogout] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const pageTitle = (k) =>
    menuItems.find((i) => i.key === k)?.label || "Espace Collectivité";

  const closeSidebar = () => setSidebarOpen(false);

  const handleSelect = (key) => {
    setActive(key);
    closeSidebar();
  };

  return (
    <div className="adminApp">
      <button
        className={`adminOverlay ${sidebarOpen ? "isOpen" : ""}`}
        aria-label="Fermer le menu"
        onClick={closeSidebar}
      />

      <aside className={`adminSidebar ${sidebarOpen ? "isOpen" : ""}`}>
        <div className="adminBrand">
          <div className="adminLogo">FD</div>
          <div className="adminBrandText">
            <div className="adminBrandTitle">FormiDoc</div>
            <div className="adminBrandSub">Espace Collectivité</div>
          </div>
        </div>

        <div className="adminProfile">
          <div className="adminProfileTop">
            <div className="adminProfileLabel">Connecté en tant que</div>
            <span className="adminRolePill">Collectivité</span>
          </div>
          <div className="adminEmail">{user?.email}</div>
        </div>

        <nav className="adminNav">
          {menuItems.map((item) => (
            <button
              key={item.key}
              className={`adminNavItem ${active === item.key ? "active" : ""}`}
              onClick={() => handleSelect(item.key)}
            >
              <span className="adminNavIcon">{item.icon}</span>
              <span className="adminNavText">{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="adminSidebarFooter">
          <button
            className="adminLogout"
            onClick={() => setConfirmLogout(true)}
          >
            <span className="adminLogoutIcon">{Icons.logout}</span>
            <span>Se déconnecter</span>
          </button>
        </div>
      </aside>

      {confirmLogout && (
        <div className="logoutModalOverlay">
          <div className="logoutModal">
            <div className="logoutModalTitle">Confirmation</div>
            <div className="logoutModalText">
              Voulez-vous vraiment vous déconnecter ?
            </div>

            <div className="logoutModalActions">
              <button
                className="btnSecondary"
                onClick={() => setConfirmLogout(false)}
              >
                Annuler
              </button>

              <button
                className="btnDanger"
                onClick={() => {
                  setConfirmLogout(false);
                  onLogout?.();
                }}
              >
                Se déconnecter
              </button>
            </div>
          </div>
        </div>
      )}

      <main className="adminMain">
        <header className="adminTopbar">
          <div className="adminTopbarLeft">
            <button
              className="adminBurger"
              aria-label="Ouvrir le menu"
              onClick={() => setSidebarOpen(true)}
              type="button"
            >
              <span />
              <span />
              <span />
            </button>

            <div>
              <div className="adminTitle">{pageTitle(active)}</div>
            </div>
          </div>

          <div className="adminTopbarRight">
            <button
              className="adminYsdaBtn"
              onClick={() => window.open("https://ysda.fr", "_blank")}
            >
              Aller sur Ysda.fr
            </button>
          </div>
        </header>

        <section className="adminContent">
          {active === "overview" && <OverviewCollectivite user={user} />}
          {active === "beneficiaires" && <BeneficiairesCollectivite user={user} />}
          {active === "rendezvous" && <RendezVousCollectivite user={user} />}
          {active === "settings" && <ParametresCollectivite user={user} />}
        </section>
      </main>
    </div>
  );
};

const OverviewCollectivite = ({ user }) => {

  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE}/collectivite/dashboard`, {
      headers: { Authorization: `Bearer ${user?.token}` },
    })
      .then(r => r.json())
      .then(data => {
        setStats(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [user]);

  if (loading) {
    return <div className="adminPlaceholder">Chargement...</div>;
  }

  // --- Date helpers Paris ---
// --- Helpers Paris (UTC-based)
// --- Helpers Paris (UTC-based)
const getParisDateString = (iso) =>
  new Date(iso).toLocaleDateString("sv-SE", {
    timeZone: "Europe/Paris"  // Utilisation du fuseau horaire de Paris
  });

// Create the true "today in Europe/Paris" based on *now in UTC*
const nowUtc = new Date().toLocaleString("en-US", {
  timeZone: "UTC"
});
const todayParis = new Date(nowUtc).toLocaleDateString("sv-SE", {
  timeZone: "Europe/Paris"
});

const rdvToday =
  (stats?.prochains_rdv || []).filter(r => {
    const rdvDateParis = getParisDateString(r.debut);
    return rdvDateParis === todayParis;
  });

const rdvFutur =
  (stats?.prochains_rdv || []).filter(r => {
    const rdvDateParis = getParisDateString(r.debut);
    return rdvDateParis > todayParis;
  });

  return (
    <>
      <div className="adminGrid">
        <KPI icon={<FaUsers />} color="#2563eb" title="Bénéficiaires actifs" value={stats?.beneficiaires_actifs || 0} />
        <KPI icon={<FaCalendarAlt />} color="#16a34a" title="RDV ce mois" value={stats?.rdv_ce_mois || 0} />
        <KPI icon={<FaClock />} color="#f59e0b" title="RDV à venir" value={stats?.rdv_a_venir || 0} />
        <KPI icon={<FaChartLine />} color="#dc2626" title="Annulations (30j)" value={stats?.rdv_annules_30j || 0} />
      </div>

      <div className="overviewCardsRow">

        {[{ title: "Prochains RDV", data: rdvFutur, showDate: true },
          { title: "RDV d’aujourd’hui", data: rdvToday, showDate: false }]
          .map((block, idx) => (
          <div key={idx} className="adminCard" style={{ flex: 1 }}>
            <div className="adminCardHeader">
              <div className="adminCardTitle">{block.title}</div>
            </div>

            {block.data.length ? (
              <div className="adminTableWrap">
                <table className="adminTable" style={{ fontSize: 13 }}>
                  <thead>
                    <tr>
                      <th>Bénéficiaire</th>
                      <th>Médecin</th>
                      <th>{block.showDate ? "Date" : "Heure"}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {block.data.map(r => (
                      <tr key={r.id}>
                        <td>{r.beneficiaire_code}</td>
                        <td>{r.medecin_nom}</td>
                        <td>
                      {block.showDate
                        ? new Date(r.debut).toLocaleString("fr-FR", {
                            timeZone: "Europe/Paris",
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit"
                          })
                        : new Date(r.debut).toLocaleTimeString("fr-FR", {
                            timeZone: "Europe/Paris",
                            hour: "2-digit",
                            minute: "2-digit"
                          })}
                    </td>
                   </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="adminMonoo" style={{ padding: 16 }}>
                Aucun rendez-vous.
              </div>
            )}
          </div>
        ))}

      </div>
    </>
  );
};

const KPI = ({ icon, color, title, value }) => (
  <div className="adminCard">
    <div className="adminCardHeader">
      <div style={{ display: "flex", alignItems: "center", gap: 8, color }}>
        {icon}
        <div className="adminCardTitle">{title}</div>
      </div>
    </div>
    <div style={{ fontSize: 26, fontWeight: 780 }}>
      {value}
    </div>
  </div>
);

export default DashboardCollectivite;